import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Grupo} from '../../shared/model/grupo/grupo.model';
import {FormFieldComponent} from '../../shared/components/form-field/form-field.component';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {SelectOneComponent} from '../../shared/components/select-one/select-one.component';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {environment} from '../../../../environments/environment';
import {SlideTogglePadraoComponent} from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {AuthService} from '../../shared/service/auth.service';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {UsuarioResumo} from '../../shared/model/usuario/usuario-resumo-model';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import {CpfValidator} from '../../shared/validator/CpfValidator';
import {UsuarioService} from '../../shared/service/usuario.service';

@Component({
  selector: 'app-modal-cadastro-visualizacao-grupo',
  standalone: true,
  imports: [
    FormFieldComponent,
    ButtonPadraoComponent,
    SelectOneComponent,
    SlideTogglePadraoComponent,
    ReactiveFormsModule
  ],
  templateUrl: './modal-cadastro-visualizacao-grupo.component.html',
  styleUrl: './modal-cadastro-visualizacao-grupo.component.css'
})
export class ModalCadastroVisualizacaoGrupoComponent implements OnInit {
  visualizar = false;
  grupo: Grupo = new Grupo();
  logoGrupo?: SafeUrl | null;
  formGrupo!: FormGroup;
  listaUsuarios: UsuarioResumo[] = [];

  private readonly dialog = inject(MatDialogRef<ModalCadastroVisualizacaoGrupoComponent>);
  public data = inject<any>(MAT_DIALOG_DATA);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly authService = inject(AuthService);
  private readonly fb = inject(FormBuilder);
  public alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly usuarioService = inject(UsuarioService);

  constructor() {
    this.formGrupo = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
      responsavel: this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        nome: ['', [Validators.required, Validators.minLength(3)]],
        telefone: ['', [Validators.required, Validators.pattern(/^\(?\d{2}\)?[\s-]?\d{4,5}-?\d{4}$/)]],
        cpf: ['', [Validators.required, CpfValidator]]
      })
    });
  }

  ngOnInit() {
    this.visualizar = this.data['visualizar'];

    this.carregarInfoGrupo();
    this.alteracaoService.camposNaoAlterados();
  }

  private carregarInfoGrupo() {
    this.grupo = this.data['grupo'];

    this.buscarUsuarios(this.grupo.id);

    this.formGrupo.get('nome')?.patchValue(this.grupo.nome);
    this.formGrupo.get('responsavel')?.patchValue(this.grupo.responsavel);
    if (this.visualizar) {
      this.formGrupo.get('responsavel')?.disable();
    }

    this.logoGrupo = this.grupo.uuid && this.grupo.logoExtensao ? this.gerarUrl(this.grupo.uuid!, this.grupo.logoExtensao!, 'grupo-logo') : null;
  }

  buscarUsuarios(grupoId?: number){
    this.usuarioService.buscarUsuarios(grupoId).subscribe({
      next: res => {
        this.listaUsuarios = [];
        this.listaUsuarios = res;
      }
    })
  }

  selecionarResponsavel(event: any){
    const formValue = this.formGrupo.value;
    formValue.responsavel = event;
    this.alteracaoService.camposAlterado()
  }

  salvar() {
    if (this.formGrupo.invalid) {
      return;
    }

    const formValue = this.formGrupo.value;
    this.grupo.nome = formValue.nome;
    this.grupo.responsavel = formValue.responsavel;


    this.dialog.close(this.grupo);
  }

  cancelar() {
    this.dialog.close();
    this.formGrupo.reset();
  }

  selecionarLogoGrupo(event: any) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target?.files[0]);
    reader.onload = () => {
      if(reader.result) {
        this.logoGrupo = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
        this.grupo.logoBase64 = reader.result.toString().split(';base64,')[1];
        this.grupo.logoExtensao = reader.result.toString().split(';base64,')[0].split('/')[1];
      }
    };
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }
}
